/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';

export default class AppSignInConfiguration extends Model {
  @attr('string') appName;
  @attr('string') samlAuthId;
  @attr('boolean') signedInWithAuthorizedMethod;
  @attr() authorizedSignInMethods;
}
